import { render, staticRenderFns } from "./TransitionVideo.vue?vue&type=template&id=2f87674b&"
import script from "./TransitionVideo.vue?vue&type=script&lang=js&"
export * from "./TransitionVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports